export default "__VITE_ASSET__BBZlpXgv__"